
import { VDError } from "@/models/VDError";
import {
  defineComponent,
  PropType,
  ref,
  onMounted,
  onBeforeUnmount,
} from "vue";
import Error from "./Error.vue";
import Spinner from "./Spinner.vue";

export default defineComponent({
  components: { Spinner, Error },
  inheritAttrs: false,
  name: "Sidebar",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: "Vent venligst ...",
    },
    error: {
      type: Object as PropType<VDError>,
      default: null,
    },
    padding: {
      type: String,
      default: "p-5",
    },
  },
  emits: ["on-hiding"],
  setup(_, { emit }) {
    const isShow = ref(false);
    const mounted = ref(false);
    let scrollPosition = 0;

    const onKey = (e: KeyboardEvent) => {
      if (e.code == "Escape") onHiding();
    };

    function disableScrolling() {
      scrollPosition = window.pageYOffset;
      const $body = document.querySelector("body");
      if ($body) {
        $body.style.overflow = "hidden";
        $body.style.position = "fixed";
        $body.style.top = `-${scrollPosition}px`;
        $body.style.width = "100%";
      }
    }

    function enableScrolling() {
      const $body = document.querySelector("body");
      if ($body) {
        $body.style.removeProperty("overflow");
        $body.style.removeProperty("position");
        $body.style.removeProperty("top");
        $body.style.removeProperty("width");
        window.scrollTo(0, scrollPosition);
      }
    }

    function hide() {
      setTimeout(() => {
        isShow.value = false;
      }, 80);
      window.removeEventListener("keyup", onKey);
      enableScrolling();
    }
    function show() {
      window.addEventListener("keyup", onKey, false);
      setTimeout(() => {
        isShow.value = true;
      }, 80);
      disableScrolling();
    }

    function onHiding() {
      emit("on-hiding");
    }

    onMounted(() => {
      mounted.value = true;
    });

    onBeforeUnmount(() => {
      mounted.value = false;
      enableScrolling();
      window.removeEventListener("keyup", onKey);
    });

    return {
      performRoute: () => {
        // Placeholder for additional logic if needed
      },
      show,
      hide,
      isShow,
      mounted,
      onHiding,
    };
  },
});
